module.exports = __webpack_public_path__ + "static/media/VNDC.6c1aac67.webp";